var headers = {
  Authorization: "Bearer " + sessionStorage.getItem("user"),
};

var constants = {
  baseApiUrl: sessionStorage.getItem("customApiPath"),
  ctsApiUrl: sessionStorage.getItem("ctsApiUrl"),
  identityApiUrl: sessionStorage.getItem("authority"),
  viewerUrl: sessionStorage.getItem("viewerUrl"),
  client_version_Id: sessionStorage.getItem("client_version_Id"),
  signUsingUAEPassEnabled: JSON.parse(
    sessionStorage.getItem("sign_using_UAEPass")
  ),
  signUsingDocusignEnabled: JSON.parse(
    sessionStorage.getItem("sign_using_Docusign")
  ),
  applicationTitle: sessionStorage.getItem("applicationTitle"),
  headers: headers,
  disclaimerMessage: sessionStorage.getItem("disclaimerMessage"),
  maxAttachmentSizeInByte: Window.maxAttachmentSizeInByte,
  maxAttachmentSizeInMb: Window.maxAttachmentSizeInMb,
  priorities: window.priorities,
  contactRolesEnum: {
    Secretary: 1,
    Managers: 5,
  },
  maxSize: 10 * 1024 * 1024, // 10 MB
  maxAttachmentsAllowed: 5,
  fileExtensions: [
    { id: 1, name: "bmp" },
    { id: 2, name: "doc" },
    { id: 3, name: "docx" },
    { id: 4, name: "gif" },
    { id: 5, name: "jpg" },
    { id: 6, name: "pdf" },
    { id: 7, name: "png" },
    { id: 8, name: "ppt" },
    { id: 9, name: "pptx" },
    { id: 10, name: "svg" },
    { id: 11, name: "txt" },
    { id: 12, name: "xls" },
    { id: 13, name: "xlsx" },
    { id: 14, name: "bmp" },
    { id: 15, name: "tif" },
    { id: 16, name: "tiff" },
  ],
  languages: [
    { id: "EN", name: "English" },
    { id: "AR", name: "العربية" },
  ],
  applicationRoles: [],
  purposes: [],

  delegations: [],
  isDelegationsLoaded: false,
  refreshSystemNotificationTimer: refreshSystemNotificationTimer,
  activeNotification: sessionStorage.getItem("activeNotification"),
  defaultDateValue: "dd/mm/yyyy",
  statuses: [
    { id: 3, name: "Draft", nameAr: "مسودة", key: "Draft", classColor: "blue" },
    {
      id: 1,
      name: "In progress",
      nameAr: "قيد التنفيذ",
      key: "InProgress",
      classColor: "orange",
    },
    {
      id: 2,
      name: "Completed",
      nameAr: "منجز",
      key: "Completed",
      classColor: "green",
    },
    // { id: 4, name: 'Canceled', nameAr: 'ملغاة', key: 'Canceled', classColor: 'danger' },
    // { id: 5, name: 'Signed', nameAr: 'موقعة', key: 'Signed', classColor: 'info' }
  ],

  statusesEnum: {
    getById: function (id) {
      const status = constants.statuses.find((s) => s.id === id);
      return status ? constants.statusesEnum[status.key] : null;
    },
    getStatusById: function (id) {
      return constants.statuses.find((status) => status.id === id) || null;
    },
    Draft: {
      key: "Draft",
      value: 3,
      data: function () {
        return constants.statuses.filter((x) => x.id == this.value)[0];
      },
    },
    InProgress: {
      key: "InProgress",
      value: 1,
      data: function () {
        return constants.statuses.filter((x) => x.id == this.value)[0];
      },
    },
    Completed: {
      key: "Completed",
      value: 2,
      data: function () {
        return constants.statuses.filter((x) => x.id == this.value)[0];
      },
    },
    Canceled: {
      key: "Canceled",
      value: 4,
      data: function () {
        return constants.statuses.filter((x) => x.id == this.value)[0];
      },
    },
    Signed: {
      key: "Signed",
      value: 5,
      data: function () {
        return constants.statuses.filter((x) => x.id == this.value)[0];
      },
    },
  },

  userActions: {},
};

export default constants;
